import * as tslib_1 from "tslib";
import { omit as lodashOmit, pick as lodashPick } from 'lodash';
export function pick(object) {
  var props = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    props[_i - 1] = arguments[_i];
  }

  return lodashPick.apply(void 0, tslib_1.__spread([object], props));
}
export function omit(object) {
  var paths = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    paths[_i - 1] = arguments[_i];
  }

  return lodashOmit.apply(void 0, tslib_1.__spread([object], paths));
}